import React, { ReactElement, } from 'react';
import { useAppSelector } from "redux/hooks";
import { Translate } from "react-redux-i18n";
import { Typography, Box } from '@mui/material';

import Iframe from 'components/shared/Iframe';
import PaymentForm from '../PaymentForm';
import styles from "./styles.module.scss";

export default function PaymentView(): ReactElement {
  const methodContent = useAppSelector(state => state.payments.payMethodContent);
  return (
    <>
      {
        methodContent ?
          methodContent.type == "link" ?
            <Iframe
              title="Payments"
              src={`${methodContent.content}`}
              height="700px"
              scrolling="yes"
              caller="payment"
            />
            :
            methodContent.type === "message" ?
              <Box className={styles.msgContainer}>
                <Typography className={styles.title}>
                  <Translate value={`payments.${methodContent.content}`} />
                </Typography>
              </Box>
              : null
          :
          <PaymentForm />
      }
    </>
  );
}